module.exports = __webpack_public_path__ + "img/icon24.66a287e1.png";